import * as ActionTypes from '../../actions/allActions'

const bookingsInit = {
	type: "future", pageFuture: 0, pagePast: 0,
	moreBookingsAvailable: { past: false, future: false }
}
const bookings = (state = bookingsInit, action) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.RESET_BOOKINGS_STATE:
		case ActionTypes.LOGOUT:
			return bookingsInit
		default:
			return state
	}
}

export default bookings



// WEBPACK FOOTER //
// ./src/reducers/metadata/bookings.js